'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { abbreviateAddress } from '@repo/utils';
import { memo, useMemo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
import { getPortfolioUrl } from '@/helpers/routing';
export interface UserCellDashboardProps {
  address: Address;
}

/**
 * UserCellDashboard displays a user address with an internal link to the user's portfolio page.
 * Use this component when you want to navigate to /portfolio/:userAddress.
 */
const UserCellDashboard = t0 => {
  const $ = _c(12);
  const {
    address
  } = t0;
  let t1;
  if ($[0] !== address) {
    t1 = abbreviateAddress(address);
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedAddress = t1;
  let t2;
  if ($[2] !== address) {
    t2 = getPortfolioUrl({
      userAddress: address
    });
    $[2] = address;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== address) {
    t3 = {
      address
    };
    $[4] = address;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== formattedAddress || $[7] !== t3) {
    t4 = {
      variant: "ghost",
      size: "default",
      label: formattedAddress,
      avatarProps: t3
    };
    $[6] = formattedAddress;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <ButtonLink href={t2} mode="internal" buttonProps={t4} />;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default memo(UserCellDashboard);